import { render, staticRenderFns } from "./AppCtaButton.vue?vue&type=template&id=4c5b557e"
import script from "./AppCtaButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCtaButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports